import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Carousel from '../components/Carousel';

import "./styles/Album.scss";

class Album extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: false,
        }
    };

    toggleCarousel() {
        const displayState = this.state.display;

        this.setState({ display: !displayState });
    }

    render() {
        const { title, articlePath, images } = this.props;
        const displayClassNames = this.state.display ? '' : 'hidden';
        const total = images.length;

        return (
            <div className="album">
                <div className="main album-header">
                    <div className="album-header-info">
                        <h3
                            className="album-header-title"
                            onClick={() => { this.toggleCarousel() }}
                        >
                            {title}
                        </h3>
                        <span className="album-header-total"> ({total} photos)</span>
                    </div>
                    {/* <div className="album-header-articleLink">
                        <Link to={articlePath}>
                            Accéder à l'article >
                        </Link>
                    </div> */}
                </div>
                <Carousel classNames={displayClassNames} images={images} />
            </div>
        );
    };
};

Album.defaultValues = {
    title: 'Titre de l\'album non défini',
    images: [],
}

Album.propTypes = {
    title: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    articlePath: PropTypes.string,
};

export default Album;


// WEBPACK FOOTER //
// ./src/components/Album.jsx